import { render, staticRenderFns } from "./custom_list.vue?vue&type=template&id=3b4d76a5&"
import script from "./custom_list.vue?vue&type=script&lang=js&"
export * from "./custom_list.vue?vue&type=script&lang=js&"
import style0 from "./custom_list.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/oem/work/Rails/tosdere_erp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3b4d76a5', component.options)
    } else {
      api.reload('3b4d76a5', component.options)
    }
    module.hot.accept("./custom_list.vue?vue&type=template&id=3b4d76a5&", function () {
      api.rerender('3b4d76a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/admin/seafarer_reg/custom_list.vue"
export default component.exports